import { useIntl } from 'react-intl';
import { Checkbox, Col, Input, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import {
  CompanyType,
  ListCompaniesQuery,
} from '@/core/domain/enterprise/Companies/Companies.types';

function CompaniesExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListCompaniesQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]} align="middle">
      <Col span={24} md={12} lg={4}>
        <Input
          value={queryParams?.cnpj}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, cnpj: value }))
          }
          placeholder={intl.formatMessage({
            id: 'companies.list.header.cnpj',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.companyType}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, companyType: value }))
          }
          placeholder={intl.formatMessage({
            id: 'companies.general.form.companyType',
          })}
          options={[
            {
              value: CompanyType.Mecanica,
              label: intl.formatMessage({
                id: 'companies.general.form.companyType.mechanics',
              }),
            },
            {
              value: CompanyType.Funilaria,
              label: intl.formatMessage({
                id: 'companies.general.form.companyType.bodyShop',
              }),
            },
          ]}
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <Checkbox
          checked={queryParams?.main}
          onChange={({ target }) =>
            setQueryParams((prev) => ({
              ...prev,
              main: target.checked,
            }))
          }
        >
          Empresa Principal
        </Checkbox>
      </Col>
    </Row>
  );
}

export default CompaniesExtraFilters;
